export default "__VITE_ASSET__92ec560c__"